// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomCheckbox_wrapper__mR27t","label":"CustomCheckbox_label__E2WdH"};